import { useEffect } from 'react'
import { useIsScreenLoading } from '@muse-web/router'

import { getCurrentScreen } from '../helpers/currentScreen'
import { getLoadStageParams, getRenderMode } from '../helpers/loadStageMarks'
import { getRenderType } from '../helpers/renderType'
import { sendPerfMetric } from '../helpers/reportWebVital'
import { isUntrackedPage } from '../helpers/untrackedPage'

let isReported = false

export const ContentDomReadyTracker = () => {
    const isScreenLoading = useIsScreenLoading()

    useEffect(() => {
        // The value counts from the document load, so after a soft navigation it would report the
        // whole time since that load
        if (
            isReported ||
            isScreenLoading ||
            getRenderType() !== 'react_ssr' ||
            isUntrackedPage(window.location.pathname)
        ) {
            return
        }

        isReported = true

        sendPerfMetric({
            name: 'content_dom_ready',
            value: performance.now(),
            screen: getCurrentScreen(),
            renderType: getRenderType(),
            extraParams: { ...getLoadStageParams(), render_mode: getRenderMode() },
        })
    }, [isScreenLoading])

    return null
}
